/* Suche, Filter und Sortierung der Rezeptuebersicht, komplett im Browser.
   Alle Rezepte stehen im HTML. Suchen und Filtern blendet nur aus,
   Sortieren haengt die Karten in neuer Reihenfolge wieder ein.

   Ohne JavaScript bleibt die ganze Leiste verborgen, weil kein einziges
   ihrer Bedienelemente ohne JavaScript etwas tut. Das Raster steht dann
   vollstaendig und unveraendert da. */
(function () {
  var FACETS = ['category', 'alcohol', 'time', 'main', 'taste'];

  /* Vergleichsform fuer die Suche. Umlaute werden ausgeschrieben, damit
     "glühwein" und "gluehwein" dasselbe ergeben. */
  function norm(value) {
    var s = String(value == null ? '' : value);
    if (s.normalize) s = s.normalize('NFC');
    s = s.toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Dieselbe Form, aber mit nacktem Vokal statt ausgeschriebenem Umlaut. */
  function normPlain(value) {
    var s = String(value == null ? '' : value);
    if (s.normalize) s = s.normalize('NFC');
    s = s.toLowerCase().replace(/ß/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Der durchsuchte Text haelt beide Schreibweisen bereit. So findet
     "glühwein", "gluehwein" und auch das getippte "gluhwein" dasselbe Rezept. */
  function haystack(value) {
    var a = norm(value);
    var b = normPlain(value);
    return a === b ? a : a + ' ' + b;
  }

  function num(el, key, fallback) {
    var n = parseInt(el.dataset[key], 10);
    return isNaN(n) || n <= 0 ? fallback : n;
  }

  function init(root) {
    if (root.dataset.rwFilterReady === '1') return;
    root.dataset.rwFilterReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-recipe]'));
    if (!items.length) return;

    var bar = root.querySelector('[data-filter-bar]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
    var countEl = root.querySelector('[data-filter-count]');
    var emptyEl = root.querySelector('[data-filter-empty]');
    var badgeEl = root.querySelector('[data-filter-badge]');
    var activeEl = root.querySelector('[data-filter-active]');
    var activeList = root.querySelector('[data-filter-active-list]');
    var resetEl = root.querySelector('[data-filter-reset]');
    var toggleEl = root.querySelector('[data-filter-toggle]');
    var groupsEl = root.querySelector('[data-filter-groups]');
    var searchEl = root.querySelector('[data-filter-search]');
    var clearEl = root.querySelector('[data-filter-search-clear]');
    var sortEl = root.querySelector('[data-filter-sort]');
    var grid = items[0].parentNode;

    var active = {};
    var query = '';

    // Suchtext einmal vorbereiten, nicht bei jedem Tastendruck
    items.forEach(function (el) { el.rwSearch = haystack(el.dataset.search); });

    function totalFacets() {
      return FACETS.reduce(function (n, f) { return n + (active[f] ? active[f].length : 0); }, 0);
    }

    function matchesFacets(el) {
      for (var i = 0; i < FACETS.length; i++) {
        var f = FACETS[i];
        if (!active[f] || !active[f].length) continue;
        var have = (el.dataset[f] || '').split(' ').filter(Boolean);
        var hit = active[f].some(function (v) { return have.indexOf(v) !== -1; });
        if (!hit) return false;
      }
      return true;
    }

    function matchesQuery(el) {
      if (!query) return true;
      var words = query.split(' ');
      for (var i = 0; i < words.length; i++) {
        if (el.rwSearch.indexOf(words[i]) === -1) return false;
      }
      return true;
    }

    function chipFor(facet, value) {
      return chips.filter(function (c) {
        return c.dataset.facet === facet && c.dataset.value === value;
      })[0];
    }

    function addActiveChip(text, label, onRemove) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rw-active-chip';
      btn.textContent = text;
      btn.setAttribute('aria-label', label);
      btn.addEventListener('click', onRemove);
      li.appendChild(btn);
      activeList.appendChild(li);
    }

    function renderActive() {
      if (!activeList) return;
      activeList.textContent = '';

      if (query && searchEl) {
        addActiveChip(searchEl.value.trim(), (searchEl.dataset.removeLabel || 'Suche entfernen'), function () {
          searchEl.value = '';
          query = '';
          if (clearEl) clearEl.hidden = true;
          apply();
          searchEl.focus();
        });
      }

      FACETS.forEach(function (f) {
        (active[f] || []).forEach(function (v) {
          var src = chipFor(f, v);
          if (!src) return;
          var text = src.textContent.trim();
          addActiveChip(text, 'Filter entfernen: ' + text, function () { setChip(src, false); });
        });
      });

      if (activeEl) activeEl.hidden = totalFacets() === 0 && !query;
    }

    function apply() {
      var shown = 0;
      items.forEach(function (el) {
        var ok = matchesFacets(el) && matchesQuery(el);
        el.hidden = !ok;
        if (ok) shown++;
      });

      if (countEl) {
        var word = shown === 1 ? countEl.dataset.singular : countEl.dataset.plural;
        countEl.textContent = shown + ' ' + word;
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (badgeEl) {
        var n = totalFacets();
        badgeEl.textContent = n;
        badgeEl.hidden = n === 0;
      }
      renderActive();
      syncUrl();
    }

    function syncUrl() {
      if (!window.history || !window.history.replaceState) return;
      var params = new URLSearchParams(window.location.search);
      FACETS.forEach(function (f) {
        if (active[f] && active[f].length) params.set(f, active[f].join(','));
        else params.delete(f);
      });
      if (searchEl && searchEl.value.trim()) params.set('q', searchEl.value.trim());
      else params.delete('q');
      if (sortEl && sortEl.value && sortEl.value !== 'default') params.set('sort', sortEl.value);
      else params.delete('sort');
      var q = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (q ? '?' + q : ''));
    }

    function setChip(chip, on) {
      var f = chip.dataset.facet;
      var v = chip.dataset.value;
      active[f] = active[f] || [];
      var i = active[f].indexOf(v);
      if (on && i === -1) active[f].push(v);
      if (!on && i !== -1) active[f].splice(i, 1);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      apply();
    }

    /* ---------- Sortierung ---------- */
    function sortBy(mode) {
      if (!grid) return;
      var sorted = items.slice().sort(function (a, b) {
        var d = 0;
        if (mode === 'time') {
          // Rezepte ohne Zeitangabe ans Ende
          d = num(a, 'minutes', 99999) - num(b, 'minutes', 99999);
        } else if (mode === 'new') {
          d = num(b, 'date', 0) - num(a, 'date', 0);
        } else if (mode === 'title') {
          d = String(a.dataset.title || '').localeCompare(String(b.dataset.title || ''), 'de');
        }
        // bei Gleichstand bleibt die im Theme gepflegte Reihenfolge
        return d || num(a, 'order', 0) - num(b, 'order', 0);
      });
      var frag = document.createDocumentFragment();
      sorted.forEach(function (el) { frag.appendChild(el); });
      grid.appendChild(frag);
    }

    /* ---------- Bedienelemente ---------- */
    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', function () {
        setChip(chip, chip.getAttribute('aria-pressed') !== 'true');
      });
    });

    if (toggleEl && groupsEl) {
      toggleEl.addEventListener('click', function () {
        var open = toggleEl.getAttribute('aria-expanded') === 'true';
        toggleEl.setAttribute('aria-expanded', open ? 'false' : 'true');
        groupsEl.hidden = open;
      });
      groupsEl.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape') return;
        toggleEl.setAttribute('aria-expanded', 'false');
        groupsEl.hidden = true;
        toggleEl.focus();
      });
    }

    if (resetEl) {
      resetEl.addEventListener('click', function () {
        active = {};
        query = '';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        if (searchEl) searchEl.value = '';
        if (clearEl) clearEl.hidden = true;
        apply();
      });
    }

    if (searchEl) {
      var timer = null;
      searchEl.addEventListener('input', function () {
        if (clearEl) clearEl.hidden = searchEl.value === '';
        clearTimeout(timer);
        timer = setTimeout(function () {
          query = norm(searchEl.value);
          apply();
        }, 150);
      });
      // Enter soll die Seite nicht neu laden, falls das Feld je in einem Formular landet
      searchEl.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') ev.preventDefault();
        if (ev.key === 'Escape' && searchEl.value) {
          ev.preventDefault();
          searchEl.value = '';
          query = '';
          if (clearEl) clearEl.hidden = true;
          apply();
        }
      });
    }

    if (clearEl) {
      clearEl.addEventListener('click', function () {
        if (!searchEl) return;
        searchEl.value = '';
        query = '';
        clearEl.hidden = true;
        apply();
        searchEl.focus();
      });
    }

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortBy(sortEl.value);
        syncUrl();
      });
    }

    /* ---------- Zustand aus der URL wiederherstellen ---------- */
    var params = new URLSearchParams(window.location.search);

    chips.forEach(function (chip) {
      var want = (params.get(chip.dataset.facet) || '').split(',').filter(Boolean);
      if (want.indexOf(chip.dataset.value) === -1) return;
      var f = chip.dataset.facet;
      active[f] = active[f] || [];
      active[f].push(chip.dataset.value);
      chip.setAttribute('aria-pressed', 'true');
    });

    if (totalFacets() > 0 && toggleEl && groupsEl) {
      toggleEl.setAttribute('aria-expanded', 'true');
      groupsEl.hidden = false;
    }

    if (searchEl && params.get('q')) {
      searchEl.value = params.get('q');
      query = norm(searchEl.value);
      if (clearEl) clearEl.hidden = false;
    }

    if (sortEl && params.get('sort')) {
      var want = params.get('sort');
      var ok = Array.prototype.some.call(sortEl.options, function (o) { return o.value === want; });
      if (ok) {
        sortEl.value = want;
        sortBy(want);
      }
    }

    if (bar) bar.hidden = false;
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-recipe-filter]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
